import { useCallback, useEffect, useState } from "react";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";

export const MANAGE_ROLES = ["Director", "Manager", "Back Office"];
export const VIEW_ROLES = [...MANAGE_ROLES, "Accounts"];

export const fmtNum = (n) => (n === null || n === undefined ? "—" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 }));

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(`${iso.slice(0, 10)}T00:00:00`);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function useServiceMasters() {
  const [types, setTypes] = useState([]);
  const [grades, setGrades] = useState([]);
  const [parts, setParts] = useState([]);
  const load = useCallback(() => {
    Promise.all([client.get("/configurations/service-types"), client.get("/configurations/grades"), client.get("/configurations/part-codes")])
      .then(([t, g, p]) => {
        setTypes(t.data);
        setGrades(g.data);
        setParts(p.data);
      })
      .catch((err) => toast.error(getErrorMessage(err)));
  }, []);
  useEffect(() => { load(); }, [load]);
  return { types, grades, parts, reload: load };
}

export const toOptions = (items, prefix) => items.map((i) => ({ value: i.id, label: i.name, testId: `${prefix}-option-${i.id}` }));

export const LEGACY_PART = "__legacy__";

// Part Code dropdown options: master items, plus the line's saved pre-master text (kept as-is) and a clear option.
export function partOptions(parts, prefix, legacyText, hasValue) {
  const opts = toOptions(parts, prefix);
  if (legacyText) opts.unshift({ value: LEGACY_PART, label: `${legacyText} (not in master)`, testId: `${prefix}-option-legacy` });
  if (hasValue) opts.push({ value: "", label: "Clear selection", pinned: true, testId: `${prefix}-option-clear` });
  return opts;
}
